import { useEffect, useRef } from "react"

// Like useEffect, but will only ever run once on unmount.
export function useUnmountEffect(effect: () => void) {
  const effectRef = useRef(effect)
  effectRef.current = effect
  useEffect(() => () => effectRef.current(), [])
}
